import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlloyButton, useModal, Modal } from 'cat-ecommerce-alloy';
import { replaceTokensInString } from '@app/utils';
import { useDispatch } from 'react-redux';
import RemoveBundleModal from '../RemoveBundleModal';
import { removeBundleModalError } from '@app/store/orders/actions';

const RemoveBundleButton = ({
  name = '',
  orderItemId,
  associatedBundleCount,
  ssroBundle,
  bundlesToRemoveCount
}) => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const removeBundleModalProps = useModal();

  const openRemoveBundleModal = () => {
    removeBundleModalProps.open();
    dispatch(removeBundleModalError());
  };
  const removeBundleForPartButton = replaceTokensInString(
    t('REMOVE_BUNDLE_BUTTON'),
    name
  );
  return (
    <div className="pt-2 pb-2 d-flex flex-column flex-md-row">
      <AlloyButton
        buttonType="secondary"
        size="dynamic"
        onClick={openRemoveBundleModal}
      >
        {!!name ? removeBundleForPartButton : t('REMOVE_BUNDLE')}
      </AlloyButton>
      <Modal
        close={removeBundleModalProps.close}
        isOpen={removeBundleModalProps.isOpen}
        title={t('REMOVE_BUNDLES')}
      >
        <RemoveBundleModal
          orderItemId={orderItemId}
          associatedBundleCount={associatedBundleCount}
          ssroBundle={ssroBundle}
          bundlesToRemoveCount={bundlesToRemoveCount}
          closeModal={removeBundleModalProps.close}
        />
      </Modal>
    </div>
  );
};

RemoveBundleButton.propTypes = {
  ssroBundle: PropTypes.arrayOf(
    PropTypes.shape({
      selfServiceOptionId: PropTypes.string,
      selfServiceOptionName: PropTypes.string
    })
  ),
  orderItemId: PropTypes.string,
  associatedBundleCount: PropTypes.number,
  bundlesToRemoveCount: PropTypes.number,
  name: PropTypes.string
};

export default RemoveBundleButton;
